import { useEffect, useState } from 'react';
import { getWindowDimensions, deviceEnquire } from './helpers';
import { DEVICE } from './constants';
import { PATH } from '../../routes/constants';

export const useWindowDimensions = () => {
  const [dimensions, setDimensions] = useState(getWindowDimensions);

  useEffect(() => {
    const handleResize = () => setDimensions(getWindowDimensions());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return dimensions;
};

export const useDevice = (setVisible: any = null) => {
  const [device, setDevice] = useState('desktop');
  useEffect(() => {
    let isMobilePath = false;
    PATH.MOBILE.forEach(reg => {
      if (!isMobilePath && reg.test(window.location.pathname))
        isMobilePath = true;
    });
    if (isMobilePath) {
      if (setVisible) {
        setVisible(false);
      }
      setDevice(DEVICE.MOBILE);
    } else {
      deviceEnquire((device: string) => {
        if (setVisible) {
          setVisible(device === DEVICE.DESKTOP);
        }
        setDevice(device);
      });
    }
  }, []);
  return {
    device,
  };
};
